import { updateFaceWithLastSeen } from '@/libraries/util/lastSeenFilter'
import { subscribe } from '@/libraries/socket'

function makeDomainCurrent (state, domain) {
  state.data.domains.current = domain
  subscribe(domain.uuid, state.authToken)

  const camerasForDomain = state.data.cameras.by.domainUUID[domain.uuid]

  if (!camerasForDomain) {
    return
  }

  if (camerasForDomain.length) {
    state.data.cameras.current = camerasForDomain[0]
  } else {
    state.data.cameras.current = undefined
  }
}

export default {
  finishLogin: (state, data) => {
    if (!data.ok) {
      return console.error('Response not OK.')
    }
    const token = data.auth.token
    const displayName = data.email

    state.authToken = token
    state.displayName = displayName
    state.email = data.email
    state.staff = data.staff
    if (window.bugsnagClient) {
      window.bugsnagClient.user = {
        name: state.displayName,
        email: state.email,
      }
    }
  },
  clearAuthToken: state => {
    state.authToken = ''
  },
  logout: state => {
    state.displayName = ''
    state.email = ''
    state.data = {
      domains: {
        all: [],
        uuids: [],
        current: undefined,
        by: {
          uuid: {},
          cameraUUID: {},
        },
      },
      cameras: {
        all: [],
        uuids: [],
        by: {
          uuid: {},
          domainUUID: {},
        },
      },
    }
    state.history = []
  },
  cacheUserData: (state, data) => {
    // coerces the token into a boolean. Basically, if there is a token,
    // https://stackoverflow.com/questions/784929/what-is-the-not-not-operator-in-javascript
    const isAuthenticated = !!state.authToken
    if (isAuthenticated) {
      state.data = data

      // If there's no camera in the router when the cache loads
      // or we couldn't find it, just default to first domain.
      if (!state.data.domains.current) {
        state.data.domains.current = state.data.domains.all[0]
        // console.log(`Activating domain: `, state.data.domains.current.uuid)
      }

      // console.log('Loaded new data in response to login: ' + JSON.stringify(data, null, 2))
      // TODO: Consider disabling local storage for this, for data security.
    } else {
      // console.log('Tried to cache user data without being logged in. Maybe the user logged in or out?')
    }
  },
  makeDomainCurrent,
  makeDomainCurrentByUUID: (state, domainUUID) => {
    const domain = state.data.domains.by.uuid[domainUUID]
    makeDomainCurrent(state, domain)
  },
  makeDomainCurrentByCameraUUID: (state, cameraUUID) => {
    const domain = state.data.domains.by.cameraUUID[cameraUUID]
    state.data.domains.current = domain
  },
  setDemoName: (state, payload) => {
    const uuid = payload.uuid
    const name = payload.name
    state.demoNames[uuid] = name
  },
  saveFrontendFaces: (state, payload) => {
    const faces = payload.faces
    state.faces = faces
  },
  /**
   * @description Depends on having faces locally store.
   */
  updateLastSeen: (state, payload) => {
    const faces = state.faces.slice()

    faces.map(face => {
      const lastSeen = payload.lastSeenData.find(element => element.frontend_face_uuid === face.frontend_face_uuid)
      return updateFaceWithLastSeen({ face, lastSeen: lastSeen })
    })

    faces.sort(
      (a, b) => new Date(a.last_seen_datetime) > new Date(b.last_seen_datetime)
    )
    // console.timeEnd('mutate last seen')
    state.faces = faces
  },
}
